<template>
  <section class="process">
    <div class="container">
      <h2>{{ process.title }}</h2>
      <p v-html="process.description"></p>
      <div class="row">
        <ProcessStep
          class="col-12"
          :class="{'col-md-4': process.articles.length > 2, 'col-md-6': process.articles.length < 3}"
          v-for="(article, index) in process.articles"
          :article="article"
          :index="index"
          :key="article.id"
        />
      </div>
      <div class="d-flex justify-content-center contact-btn">
        <ButtonRed
          v-if="process.contactButton.showModalButton"
          :text="process.contactButton.title"
          @click="handleModal"
        />
      </div>
      <ModalForm
        :modal="process.contactButton.modal"
        :successModalData="process.contactButton.successModal"
        :show="showModal"
        @handleModal="handleModal"
      />
    </div>
  </section>
</template>

<script setup>
import ProcessStep from "@/components/header-process/ProcessStep";
import {ref} from "vue";
import ModalForm from "@/components/common/modals/ModalForm.vue";
import ButtonRed from "@/components/common/ButtonRed.vue";

defineProps({
  process: {
    title: String,
    description: String,
    articles: Array,
    contactButton: {
      title: String,
      showModalButton: String,
      modal: Object,
      successModal: Object
    }
  }
})

const showModal = ref(false);
const handleModal = () => showModal.value = !showModal.value;
</script>
